import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';

export default function Assets() {
  const navigate = useNavigate();
  
  return (
    <Layout>
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Critical Assets</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600">Asset management interface coming soon...</p>
        </div>
      </div>
    </Layout>
  );
}
